import React,{useRef, useEffect, useState, useLayoutEffect} from "react";
import {GalleryV1} from '../Products/Gallery'
import { FromatNumberVIE, RoundFloor } from '../../utils/format'
import { actionCart } from '../../service/cartService';
import { getStoreBySKU } from "../../service/storeService";
import {BundleProductV1} from "../BundleProduct";
import { ProductSameV1 } from "../ProductSame";
import Breadsrumb1 from "../Breadcrumbs/Breadcrumb1";
import { TabView, TabPanel } from 'primereact/tabview';
import { DescriptionV1 } from "../Products/description";
import { useLocation } from '@reach/router';
import { getListGiftDetail, getListGift_v1, getListPromotion_v1, getListPromotion_v2 } from '../../service/campaignService';
import {getMenuByUrl} from "../../service/myProductService";
import {pushtracking} from '../../service/trackingService';
import {FunctionId, responsiveproductlist } from "../../utils/constant";
import Img from "../Images";
import { isAuth } from "../../helpers/general";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "./ProductdetailV1.css";
import { toast } from "react-toastify";

// var _ = require('lodash');
const Productdetail =(item)=>{
  const location = useLocation();
  if (item?.item === 'Không tìm thấy thông tin sản phẩm!') {
    // window.location.href = '/404.html';
    window.location.href = location.origin;
}
  let uri = location.pathname?.replace('.html', '').replace('/', '');
  const skuRef = useRef(null);
  const nameRef = useRef(null);
  const imgRef = useRef(null);
  const quanityRef = useRef(null);
  const colorRef = useRef(null);
  const sizeRef = useRef(null);
  const priceRef = useRef(null);
  const pricediscountedRef = useRef(null);
  const percen = +item.item?.price?.discount / item.item?.price?.raw * 100;
  const [skuProduct, setskuProduct] = useState(item.sku);
  const [quantity, setQuantity] = useState(1);
  const temp_color = [];
  const [temp_color_only, settemp_color_only] = useState([]);
  const _temp_color_only = [];
  const data_color = [];
  const [data, setData] = useState(data_color);
  const [size, setSize] = useState([]);
  const [idSize, setIdSize] = useState(0);
  const [idSizeCheck, setIdSizeCheck] = useState(false);
  const [valueColor, setValueColor] = useState();
  const [selectedColor, setSelectedColor] = useState(0);
  const [selectedSize, setSelectedSize] = useState();
  var _color = [];
  const [promoCode, setPromoPode] = useState('');
  const [combCode, setComboCode] = useState('');
  // const [promoType, setpromoType] = useState('');
  const [uuDai, setUuDai] = useState('');
  const [msgGift, setMsgGift] = useState([]);
  const [store, setStore] = useState(0);
  const [configMsg, setConfigMsg] = useState(false);
  const [configMsgGift, setConfigMsgGift] = useState(false);
  const [fgGift, setFggift] = useState(false);
  const loadPromotionMsg = async (sku, type) => {
      if (sku !== undefined && type !== '') {
        await  getListGiftDetail(sku, type).then((reponse) => {
              if (reponse?.status === 200) {
                  setMsgGift(reponse?.message?.messageBrand);
              }
          });

      }
  }
  const handlePlusClick = () => {
    if(quantity > 49){
      quanityRef.current.value = 50;
      setQuantity(50);
    }else{
      quanityRef.current.value = quantity + 1;
      setQuantity(quantity + 1);
    }
    if (promoCode !== '' && combCode !== '') {
      let _param = {
          "product": item.item?.sku,
          "type": "item",
          "action": "add",
          "quantity": quantity + 1,
          "price": item.item?.price.discount,
          "promo_code": promoCode,
          "combo_code": combCode,
          "promo_type":  item.item?.typectkm,
          "uudai": uuDai,
          "user_referral": window.localStorage.getItem('userReferral'),
          "id_share": window.localStorage.getItem('idShare')
      }
      addCart(_param);
  }
  };

  const handleMinusClick = () => {
    if (quantity > 1) {
        quanityRef.current.value = quantity - 1;
        setQuantity(quantity - 1);
        if (promoCode !== '' && combCode !== '') {
          let _param = {
              "product": item.item?.sku,
              "type": "item",
              "action": "add",
              "quantity": quantity - 1,
              "price": item.item?.price.discount,
              "promo_code": promoCode,
              "combo_code": combCode,
              "promo_type": typekm,
              "uudai": uuDai,
              "user_referral": window.localStorage.getItem('userReferral'),
              "id_share": window.localStorage.getItem('idShare')
          }
          addCart(_param);
      }
    }
  };
  const handleChange =(e)=>{
    if(!parseInt(e.target.value) || +e.target.value < 0) {
      // toast.warning('Vui lòng nhập số lượng');
      quanityRef.current.value = 1;
      setQuantity(1);
    }else{
      quanityRef.current.value = e.target.value;
      setQuantity(+e.target.value);
    }
    if(!parseInt(e.target.value) || +e.target.value > 50 ) {
      quanityRef.current.value = 50;
      setQuantity(50);
    }
  }

  const handleChangeGift =(e)=>{
    if(!parseInt(e.target.value) || +e.target.value < 0) {
      // toast.warning('Vui lòng nhập số lượng');
      e.target.value = 0;
    }
    if(!parseInt(e.target.value) || +e.target.value > 50 ) {
      e.target.value = 50;
    }
  }

  const [itemProductGift, setItemProductGift] = useState([]);
  const [itemProductGiftFull, setItemProductGiftFull] = useState([]);
  const loadDataGift = (sku, type) => {
    setItemProductGift([]);
    if (sku !== undefined) {

      if (window.localStorage.getItem("tempCart")) {
        param_gift = JSON.parse(window.localStorage.getItem("tempCart"));
      }
      if (param_gift.length > 0) {
        param_gift?.forEach((item, key) => {
          qty[item.product] = item.quantity;
        })
      }
      setArrayQty(qty);

        getListGift_v1(sku, type).then((reponse) => {
            if (reponse?.status === 200) {
              // setItemProductGift(reponse?.message?.products);
              var _array = [];
              reponse?.message?.products?.forEach((item, i) => {
                
                  if(item.sku !== sku){
                      _array.push(item);
                  }
                  if(item.sku === sku){
                    item['qtypick'] = 1;
                  }else{
                    item['qtypick'] = arrayqty[item.sku];
                  }
              });
              setItemProductGift(_array);
              // var sortedObjs = _.sortBy(reponse?.message?.products, 'qtypick');
              // setItemProductGiftFull(sortedObjs);
              // setItemProductGiftFull(reponse?.message?.products?.sortBy('qtypick'));

              setItemProductGiftFull(reponse?.message?.products?.sort(
                (p1, p2) => 
                (p1.qtypick < p2.qtypick) ? 1 : (p1.qtypick > p2.qtypick) ? 0 : -1));

            }
        });
        if (window.localStorage.getItem("tempCart") && window.localStorage.getItem("tempCart") !== '') {
            let param_gift_old = JSON.parse(window.localStorage.getItem("tempCart"));

            param_gift_old.map((item, key) => {
                if (item.type === 'gift') {
                    param_gift_old.splice(key);
                }
            });
            window.localStorage.setItem("tempCart", JSON.stringify(param_gift_old));
        }
    }
  }

  const [itemsListPromotion, setItemsListPromotion] = useState([]);
  const [totalPriceCombo, setTotalPriceCombo] = useState(0);
  const [msgTotal, setMsgTotal] = useState('');
  const [totalGiftQty, setTotalGiftQty] = useState(0);
  const [listGift, setListGift] = useState([]);
  const getDataListPromotion = (params, type) => {
    try {
        if (params !== undefined) {
          getListPromotion_v2(params, type).then((response) => {
                if (+response.status === 200) {
                    setPromoPode(response.message?.products[0]?.promo_code);
                    setComboCode(response.message?.products[0]?.nameGroup);
                    let listPromotion = response.message?.products;
                    if(listGift.length>0){
                      const updateListPromotion = [...listPromotion];
                      listGift.forEach(element => {
                        const isItemExist = updateListPromotion.find(_item => _item.sku_gifts === element.sku_gifts);
                        if (isItemExist) {
                          isItemExist.quantity = element.quantity;
                        }else{
                          listPromotion.push(element);
                        }
                      });
                    }
                    setItemsListPromotion(listPromotion);
                    setTotalPriceCombo(response.message?.total_price_combo);
                    setMsgTotal(response.message?.mes_text);
                    setTotalGiftQty(response.message?.soluong_tang_gifts);
                    setUuDai(response.message?.products[0]?.uudai);
                    if (window.localStorage.getItem("tempCart")) {
                      param_gift = JSON.parse(window.localStorage.getItem("tempCart"));
                      }
                      var total_price_gift = 0;
                      var total_qty = 0;
                      param_gift?.forEach((_item) => {
                          if (_item.type === "gift") {
                              total_price_gift = +total_price_gift + (_item.price * _item.quantity);
                              total_qty = total_qty+_item.quantity;
                          }
                      });
                      if (total_price_gift > +response.message?.total_price_combo) {
                        toast.error("Quà tặng vượt quá giá trị KM được hưởng");
                      }
                } else {
                    setPromoPode('');
                    setComboCode('');
                    setTotalPriceCombo(0);
                    setMsgTotal('');
                    setTotalGiftQty(0);
                }
            });
        }
    } catch (error) {
        console.log(error);
    }
}

  const [showDsc, setShowDsc] = useState(false);
  const [scrollPosition, setPosition] = useState(0);
  useLayoutEffect(() => {
    function updatePosition() {
      setPosition(window.pageYOffset);
      window.localStorage.setItem("scrollPosition", window.pageYOffset);
      if(window.pageYOffset>450){
        setShowDsc(true);
      }
    }
    window.addEventListener('scroll', updatePosition);
    updatePosition();

    return () => window.removeEventListener('scroll', updatePosition);

}, []);
const [breandcrumb, setBreandcrumb] = useState([]);
  const [img, setImg] = useState([]);
  const [showSize, setShowSize] = useState(false);
  const [showmap, setShowMap] = useState(false);
  const [typekm, setTypekm] = useState('');
  const [showProductGift, setShowProductGift] = useState(false);
  const [showH, setShowH]= useState(450);
  useEffect(()=>{
    if (item?.item === 'Không tìm thấy thông tin sản phẩm!') {
      // window.location.href = '/404.html';
      window.location.href = location.origin;
  }

    setShowSize(false);
    setShowDsc(false);
    setShowProductGift(false);
    loadPromotionMsg(item.item?.sku, item.item?.typectkm);
    // LoadCategory();
    var array_img = {};
      item.item?.children?.forEach((it, i) => {
          array_img[it.sku]=it.thumbnail_mini;
          if(_color.includes(it.variant?.mau_sac) !== true){
              _color.push(it.variant?.mau_sac)
          }
          temp_color.push({
              color: it.variant?.mau_sac,
              sku: it.variant?.sku
          })
          _temp_color_only.push({
              id: i,
              colorName: it.variant?.mau_sac,
              sku: it.variant?.sku,
              online: it.online
          });
        }
      );
  setImg(array_img);
  _color.forEach((_temp_color,i)=>{
  const data_size = [];
  temp_color?.forEach((color) => {
          if(_temp_color === color.color){
              item.item?.children?.forEach((item_chil) => {
                  if (item_chil.variant?.kich_c !== null && item_chil.variant?.sku === color.sku) {
                      data_size.push({
                          colorSize: item_chil.variant?.kich_c,
                          sku: item_chil.variant?.sku,
                          online: item_chil.online
                      })
                  }
              }
              );
          }
      });
      if (data_size.length >= 1) {
          data_color.push({
              color: { id: i, colorName: _temp_color , sku: data_size[0].sku},
              size: data_size
          })
          setIdSizeCheck(true);
      }else{
          settemp_color_only(_temp_color_only);
          setskuProduct(_temp_color_only[0]?.sku ?? item.item?.sku);
      }
  });
    setData(data_color);
    setValueColor(data_color[0]?.color?.colorName);
    setSize(data_color[0]?.size);

    window.localStorage.setItem("tempCart", '');
    try {
      //bỏ hàng quà tặng
      if (item.item?.typectkm !== undefined) {
          setTypekm(item.item?.typectkm);
          loadDataGift(item.item?.sku, item.item?.typectkm);
           // loadPromotionMsg(item.item?.sku, item.item?.typectkm);
          let _param = [{
              itemCode: item.item?.sku,
              price: item.item?.price.discount,
              quantity: 1
          }]
          getDataListPromotion(_param, item.item?.typectkm);
      }
      // getDataStoreBySKU( item.item?.sku);
  } catch (err) {
      console.error(err);
  }
  getDataStoreBySKU(item.item?.sku);

var _pageViewDetailMSG = sessionStorage.getItem("pageViewDetailMSG");
if (_pageViewDetailMSG !== undefined && +_pageViewDetailMSG !== 1) {
    if(item.item?.function !== undefined && FunctionId.includes(item.item?.function)===true){
        if(item.item?.attribute?.age_group_from !== undefined && +item.item?.attribute?.age_group_from < 24){
            setTimeout(function() {
                setConfigMsg(true);
            }, 9000);
            // setConfigMsg(true);
            sessionStorage.setItem("pageViewDetailMSG", 1);
        }
    }
} 

if (item.item?.typectkm && item.item?.typectkm === "MUAHANGTANGQUA" ||  item.item?.typectkm  === 'MUAHANGATANGHANGA') {
  let _param = {
      "product": item.item?.sku,
      "type": "item",
      "action": "add",
      "quantity": 1,
      "price": item.item?.price.raw,
      "promo_code": promoCode ?? '',
      "combo_code": combCode ?? '',
      "promo_type": item.item?.typectkm ?? '',
      "uudai": uuDai ?? '',
      "user_referral":  window.localStorage.getItem('userReferral'),
      "id_share":   window.localStorage.getItem('idShare')
  }
  addCart(_param);
  setFggift(true);
  }
  if(item.item?.typePromotion === 3){
    setShowH(900);
  }
  },[item])

  useEffect(()=>{
    LoadCategory();
  },[])

  const LoadCategory = async ()=>{
    try {  
      await getMenuByUrl(location.pathname?.replace('/', '')+"?mode=pc").then((response)=>{
        if(response.status === 200){
          setBreandcrumb(response.message);
        }
      })
    } catch (error) {
      console.log(error);
    }
  }
    const handleColorOnlyClick = (e) => {
      const id = e?.target.id;
      setSelectedColor(+id);
      const skuValue = e?.target.getAttribute("sku");
      skuRef.current.value = skuValue;
      setskuProduct(skuValue);
      getDataStoreBySKU(skuValue);
      setSelectedSize(skuValue);
  };
  const handleColorClick = (e) => {
    const id = e?.target.id;
    setSelectedColor(+id);
    setSize(data[id]?.size);
    setValueColor(data[id]?.color?.colorName);
    setskuProduct('');
    setSelectedSize('');
    setStore(0)
};
const handleSizeClick = (e) => {
  const id = e?.target.id;
  setIdSize(id);
  const skuValue = e?.target.getAttribute("sku");
  skuRef.current.value = skuValue;
  setskuProduct(skuValue);
  getDataStoreBySKU(skuValue);
  setSelectedSize(skuValue);
};

let handleBy = async (e) => {
  e.preventDefault();
  if (isAuth() === false) {
      //toast.error('Bạn cần đăng nhập trước khi mua hàng.');
      window.localStorage.setItem('urlBack', location.pathname);
      setTimeout(() => { window.location.href = '/dang-nhap.html' }, 3500);
  } else {

      if(idSizeCheck === true){
          if(idSize === 0){
              toast.warn('Vui lòng chọn thông tin kích cỡ.');
              return;
          }
      }
      if (window.localStorage.getItem("tempCart") && window.localStorage.getItem("tempCart") !== '') {
          let param_product_to_cart = JSON.parse(window.localStorage.getItem("tempCart"));
          param_product_to_cart.forEach(param_product_cart => {
              if(param_product_cart.product === item.item?.sku){
                param_product_cart.quantity = +quanityRef.current.value;
              }
          });
          pushtoCart({ "items": param_product_to_cart });
          if(showProductGift === true){
            setShowProductGift(!showProductGift);
          }
          
      } else {
          let params = {
              items: [{
                  product: skuRef.current.value,
                  type: 'item',
                  action: 'add',
                  quantity: +quanityRef.current.value,
                  promo_code: promoCode,
                  combo_code: combCode,
                  promo_type: typekm,
                  uudai: uuDai,
                  user_referral: window.localStorage.getItem('userReferral'),
                  id_share: window.localStorage.getItem('idShare')
              }]
          }
          pushtoCart(params);
          if(showProductGift === true){
            setShowProductGift(!showProductGift);
          }
      }
  }
};
const pushtoCart = (paramItem, redirect = false) => {
  if (isAuth() === true) {
      try {
          actionCart(paramItem, window.localStorage.getItem('key')).then((response) => {
              if(+response.status === 200 && response.message.length > 0){
              window.localStorage.setItem('reloadCart', true);
              window.localStorage.setItem('itemsCart', JSON.stringify(response['message']));
              if (response['message'].includes('Yêu cầu không') === true) {
                  toast.warning(response['message']);
                  return;
              } else {
                  toast.success('Thêm vào giỏ hàng thành công.');
                  if (redirect) { setTimeout(() => { window.location.href = '/cart.html'; }, 2500); }
              }
              }
          })

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push({
                  'event': 'add_to_cart',
                  'ecommerce': {
                  'currency': "VND",
                  'value': +item.item?.price.raw,
                      'items': [
                      {
                          item_id: skuRef.current.value,
                          item_name: item.item?.name,
                          price: +item.item?.price.raw
                      }
                      ]
                  }
            });

            try{
                pushtracking(window.localStorage.getItem('sessionId')??null,
                window.localStorage.getItem('_id')??null,
                window.localStorage.getItem('phone')??null ,
                location.pathname, "Chi tiết sản phẩm", 0,0,'index','inWeb',[skuRef.current.value],'Website PC').then((response)=>{
                    console.log('send tracking');
                });
            }catch(e){console.log(e)}

      } catch (err) {
          console.log(err);
      }
  }
}
const [dataStore, setDataStore] = useState([]);
const getDataStoreBySKU = (sku) => {
  try {
      if (sku !== undefined) {
          getStoreBySKU(sku).then((response) => {
              if (+response.status === 200) {
                  setStore(response.message.length ?? 0)
                  setDataStore(response.message);
              }
          });
      }
  } catch (error) {
      console.log(error);
  }
}

const [showaddtocart, setShowaddtocart] = useState(true);
const handleListPlusClick = (sku, item, gift) => {
  var _value = 0;
  if(document.getElementById("quantity_" + sku)){
    var el = document.getElementById("quantity_" + sku);
    _value = el.value;
    if(_value > 49){
      el.value = 50;
    }else{
      el.value = +_value + 1;
    }
  }
 
  if(document.getElementById("quantity_" + sku+"_1")){
    var el_1 = document.getElementById("quantity_" + sku+"_1");
    _value = el_1.value;
    if(el_1 > 49){
      el_1.value = 50;
    }else{
      el_1.value = +_value + 1;
    }
  }

    if (gift === true) {
      if (window.localStorage.getItem("tempCart")) {
          param_gift = JSON.parse(window.localStorage.getItem("tempCart"));
      }
      var total_price_gift = 0;
      var total_qty = 0;
      param_gift?.forEach((_item) => {
          if (_item.type === "gift") {
              total_price_gift = +total_price_gift + (_item.price * _item.quantity);
              total_qty = total_qty+_item.quantity;
          }
      });
      total_price_gift = total_price_gift + item.price_import;
        if (typekm === 'MUAHANGTANGQUA') {
          // if (msgTotal !== '') {
          //     toast.warning(msgTotal);
          //   }
           if (total_price_gift > totalPriceCombo) {
              toast.error("Quà tặng vượt quá giá trị KM được hưởng");
              if(document.getElementById("quantity_" + sku+"_1")){
                var el_1 = document.getElementById("quantity_" + sku+"_1");
                el_1.value = +_value;
              }
              total_price_gift = +total_price_gift - (item.price_import * item.quantity);
                total_qty = total_qty+item.quantity;
              el.value = +_value;
              // setShowaddtocart(false);
              return;
          }
        }
        if (typekm === 'MUAHANGATANGHANGA') {
          // if (msgTotal !== '') {
          //     toast.warning(msgTotal);
          // }
          if (total_qty > totalGiftQty) {
              toast.error("Quà tặng vượt quá số lượng KM được hưởng");
              el.value = +_value;
              if(document.getElementById("quantity_" + sku+"_1")){
                var el_1 = document.getElementById("quantity_" + sku+"_1");
                el_1.value = +_value;
              }
              total_price_gift = +total_price_gift - (item.price_import * item.quantity);
              total_qty = total_qty+item.quantity;
              // setShowaddtocart(false);
              return;
          }
        }
    
      }
      var _type = '';
      var _price = 0;
      var _sku = '';
      if (gift === true) {
          _type = 'gift';
          _price = item.price_import;
          _sku = item.sku_gifts;
      } else {
          _type = 'item';
          _price = item.price?.discount;
          _sku = item.sku;
      }

      let _param = {
          "product": _sku,
          "type": _type,
          "action": "add",
          "quantity": +_value + 1,
          "price": _price,
          "promo_code": item.promo_code,
          "combo_code": combCode,
          "promo_type": typekm,
          "uudai": uuDai,
          "user_referral": window.localStorage.getItem('userReferral'),
          "id_share": window.localStorage.getItem('idShare')
      }
      addCart(_param);
      if(gift === true) {
        if(listGift.length>0)
          {
          const isItemExist = listGift.find(_item => _item.sku_gifts === item.sku_gifts);
          if (!isItemExist) {
            item['quantity']= +_value + 1;
            setListGift(prevlistGifts => [...prevlistGifts, item]);
          } else {
            item.quantity = isItemExist.quantity + 1;
            setListGift(prevListGifts => prevListGifts.filter(_item => _item.sku_gifts !== item.sku_gifts));
            setListGift(prevlistGifts => [...prevlistGifts, item]);
          }
        }else{
          item['quantity']= +_value + 1;
          setListGift([item]);
        } 
      }
      setShowaddtocart(true);
};

const handleListMinusClick = (sku, item, gift) => {
  let _value = 0;
  if(document.getElementById("quantity_" + sku)){
    var el = document.getElementById("quantity_" + sku);
    _value = el.value;
    if (_value > 0){
      el.value = +_value - 1;
    }
    
  }
  if(document.getElementById("quantity_" + sku+"_1")){
    var el_1 = document.getElementById("quantity_" + sku+"_1");
    _value = el_1.value;
    if (_value > 0){
      el_1.value = +_value - 1;
    }
  }
    if (_value > 0) {
        var _type = '';
        var _price = 0;
        var _sku = '';
        if (gift === true) {
            _type = 'gift';
            _price = item.price_import;
            _sku = item.sku_gifts;
        } else {
            _type = 'item';
            _price = item.price?.discount;
            _sku = item.sku;
        }
        let _param = {
            "product": _sku,
            "type": _type,
            "action": "add",
            "quantity": +_value - 1,
            "price": _price,
            "promo_code": promoCode,
            "combo_code": combCode,
            "promo_type": typekm,
            "uudai": uuDai,
            "user_referral": window.localStorage.getItem('userReferral'),
            "id_share": window.localStorage.getItem('idShare')
        }
        addCart(_param);
        
        if(gift === true) {
          if(listGift.length>0)
            {
            const isItemExist = listGift.find(_item => _item.sku_gifts === item.sku_gifts);
            if (isItemExist) {
              item.quantity = isItemExist.quantity - 1;
              setListGift(prevListGifts => prevListGifts.filter(_item => _item.sku_gifts !== item.sku_gifts));
              setListGift(prevlistGifts => [...prevlistGifts, item]);
            }
          }
        }
    }
  
};

var param_gift = [];
const addCart = (param) => {
    var count_item = 0;
    var count_gift = 0;
    var total_price = 0;
        if (window.localStorage.getItem("tempCart")) {
            param_gift = JSON.parse(window.localStorage.getItem("tempCart"));
        }
        if (param_gift.length > 0) {
            param_gift?.forEach((item, key) => {
                if (item.product === param.product && item.type === param.type) {
                    param_gift.splice(key, 1);
                }
                item['promo_code'] = promoCode;
                item['combo_code'] = combCode;
                item['promo_type'] = typekm;
                item['uudai'] = uuDai;
            })
            if(param.quantity>0){
              param_gift.push(param);
            }
        } else {
          if(param.quantity>0){
            param_gift.push(param);
          }
        }
        window.localStorage.setItem("tempCart", JSON.stringify(param_gift));

        const product_key = [];
        // product_key.push(119895);
        product_key.push(skuProduct);
        var total_price_gift = 0;
        var total_qty = 0;
        param_gift?.forEach((item) => {
            if (item.type === "gift" && item.quantity > 0) {
                total_price_gift = total_price_gift + (item.price * item.quantity);
                total_qty = total_qty + item.quantity;
                count_gift = count_gift + 1;
            }
            if (item.type === 'item') {
                product_key.push(item.product);
                count_item = count_item+1;
                total_price = total_price + (item.quantity * item.price)
            }
        });
        var array_param = [];
        param_gift?.forEach((item) => {
            if (item.type !== "gift") {
                var _temp = {
                    itemCode: item.product,
                    price: item.price,
                    quantity: +item.quantity
                }
                array_param.push(_temp);
            }
        });
        if (param.type === "gift") {
            if (typekm === 'MUAHANGTANGQUA') {
                // if (msgTotal !== '') {
                //     toast.warning(msgTotal);
                //     // setShowaddtocart(false);
                // }  
                if (total_price_gift > totalPriceCombo) {
                    toast.error("Quà tặng vượt quá giá trị KM được hưởng");
                    setShowaddtocart(false);
                }
            }
            if (typekm === 'MUAHANGATANGHANGA') {
                // if (msgTotal !== '') {
                //     toast.warning(msgTotal);
                //     // setShowaddtocart(false);
                // }
                if (total_qty > totalGiftQty) {
                    toast.error("Quà tặng vượt quá số lượng KM được hưởng");
                    setShowaddtocart(false);
                }
            }

        }
        let key_product = JSON.stringify(product_key).replaceAll('"', '').replaceAll('[', '').replaceAll(']', '');
        if (param.type === 'item') {
          getDataListPromotion(array_param, typekm);
          loadPromotionMsg(key_product, typekm);
        }
        setCountitem(count_item);
        setCountgift(count_gift);
        setTotalPrice(total_price);
        setShowaddtocart(true);
    }
  const [arrayqty, setArrayQty] = useState([]);
  var qty = [];
  const [countitem, setCountitem] = useState(0);
  const [countgift, setCountgift] = useState(0);
  const [totalprice, setTotalPrice] = useState(0);
  const handleShowpoppup = ()=>{
    var count_item = 0;
    var count_gift = 0;
    var total_price = 0;
    setShowProductGift(true);
    if (window.localStorage.getItem("tempCart")) {
      param_gift = JSON.parse(window.localStorage.getItem("tempCart"));
    }
    if (param_gift.length > 0) {
      param_gift?.forEach((item, key) => {
        qty[item.product] = item.quantity;
        if (item.type === 'item') {
          count_item = count_item+1;
          total_price = total_price + (item.quantity * item.price)
        }
        if (item.type === 'gift') {
          count_gift = count_gift+1;
        }
      })
    }
    setArrayQty(qty);
    setCountitem(count_item);
    setCountgift(count_gift);
    setTotalPrice(total_price);
  }

  // console.log(data);

    return (
      <>
      <div className="position-relative">
      {/* noti */}
        {/* <div className="row ps-2 align-items-center position-absolute notify">
          <div className="col-1 p-0">
            <img src="/static/image/icon_notify.gif" alt="" />
          </div>
          <div className="col-10 title_noti p-0 ps-4 ">
            <span>Đang có 300 Hotdeal giá siêu hời</span>
            <span>Săn ngay kẻo lỡ Ba Mẹ ơi!</span>
          </div>
          <div className="col-1">
            <button><i className="bi bi-chevron-right"></i></button>
          </div>
        </div> */}
       
        <div className="container mx-auto p-0 pb-4">
          <input ref={skuRef} hidden name="sku" defaultValue={skuProduct ?? item.item?.sku} />
          <input ref={nameRef} hidden name="name" defaultValue={item.item?.name} />
          <h2 className="d-none">{item.item?.name}</h2>
          <input ref={imgRef} hidden name="img" defaultValue={item.item?.thumbnail_mini} />
          <div className="row p-0 m-0 row--maint mb-4 product-detail-breandcrumb">
          <Breadsrumb1 data={breandcrumb}/>
          </div>

          <div className="row mt-3 row--maint" id="info_product">
            
            <div className="col-6 image_product overflow-y-hidden">
              <div className="row">
                 <div className="col-12 position-relative">
                 {
                    item.item?.attribute ? (<GalleryV1 images={item.item?.attribute?.images} />) : (null)
                  }
                  {
                    //&& item.item?.namePromotion !== 'Mua là có quà' 
                      item.item?.namePromotion && item.item?.namePromotion !== '' ? (<div className="position-absolute hotdeal_detail"><span>{item.item?.namePromotion}</span></div>) : (null)
                  }
                 </div>
                 

              </div>
            </div>
           
            <div className="col-6 products_infomation">
              <div className="row">
                <div className="col-12 px-0 name mb-2">
                  <span> {item.item?.name} </span>
                </div>

                <div className="col-12 px-0 info mb-3">
                  {
                    item.item?.attribute?.brand_name && item.item?.attribute?.brand_name !== '' ? (
                      <>
                      <span>Thương hiệu: 
                      {/* color-link-blue */}
                        <a className="brand-name text-color" href={item.item?.attribute?.url_brand ? item.item?.attribute?.url_brand+".html" : null}>
                        &ensp;{item.item?.attribute?.brand_name ? item.item?.attribute?.brand_name : null}
                        </a>
                      </span>
                      <img className="img-flg" src="/static/image/Vector_145.png" alt="icon" />
                      </>
                  ):(null)
                  }
                  <span>MSP: <strong>{item.item?.sku}</strong></span>
                </div>

                <div className="col-12 px-0 price price-box">
                  <div className="row">
                    <div className="col-6  align-items-center d-flex align-self-center">
                    {
                      item.item?.price ? (
                            +item.item?.price.discount == +item.item?.price.raw ? (
                              <>
                                  <span className="new">{FromatNumberVIE(item.item?.price.raw)}đ</span>
                                  <input hidden ref={priceRef} name="price" defaultValue={item.item?.price.raw} />
                                  <input hidden ref={pricediscountedRef} name="price_old" defaultValue="0" />
                              </>
                          ) : (
                              <>
                                  <input hidden ref={priceRef} name="price" defaultValue={item.item?.price.discount} />
                                  <input hidden ref={pricediscountedRef} name="price_old" defaultValue={item.item?.price.raw} />
                                  <span className="new">{FromatNumberVIE(item.item?.price.discount)}đ</span>
                                  <span className="old "><del>{FromatNumberVIE(item.item?.price.raw)}<span className="text-decoration-underline fw-semibold">đ</span></del></span>
                                  <span className="sale">-{RoundFloor(100 - percen)}%</span>
                              </>
                          )
                      ):(null)
                    }
                    
                    </div>
                    <div className="col-6  position-relative">
                      
                          {
                            +item.item?.bixu > 0 ? (
                              <>
                                <div className="bixu text-end">
                                  <span> +{FromatNumberVIE(item.item?.bixu)} BiXu </span>
                                </div>
                                <div className="icon-bixi"><img src="/static/image/bixu-gif.gif" alt="bixu" /> </div>
                              </>
                            ):(null)
                          }
                        
                        
                    </div>
                
                    {
                      msgGift.length > 0 ? (
                          <div className="col-12 box-gift-info position-relative">
                            <span className="gift_info" key={1}>{ msgGift[0].substring(0,91)+'...'}</span>
                            {
                              msgGift.length > 1 || msgGift[0].length >=89 ? (<img className="more_icon" onClick={()=>setConfigMsgGift(true)} src="/static/image/icon_1.png" alt="" />):(null)
                            }
                          </div>
                      ) : (null)
                    }
                  </div>
                </div>
                {
                    temp_color_only.length >= 1 ? (
                        <div className="col-12 px-0 properties">
                           <span>Màu sắc</span>
                            <div className="row p-0">
                              {
                                  temp_color_only?.map((item, i) => {
                                      return item?.colorName !== '' ? (
                                          item.online === true ? (<div key={item.id} data={item.id} className={item.id == selectedColor ? 'active p-0 pointer' : 'p-0 pointer'}
                                              sku={item.sku}
                                              onClick={(e) => handleColorOnlyClick(e)}
                                          >
                                            <img sku={item.sku} id={i} className="w-100" src={img[item.sku]} alt={item?.colorName} />
                                          </div>) : (null)
                                      ) : (null)
                                  })
                              }
                            </div>
                        </div>
                    ) : (null)
                }
                {
                    data && data.length >= 1 ? (
                      <>
                      {
                            data[0]?.color?.colorName !== '' && data[0]?.color?.colorName !== null ? (
                            <div className="col-12 px-0 properties">
                              <span>Màu sắc</span>
                                <div className="row p-0">
                                  {
                                    data?.map((item, i) => {
                                       return item?.color?.colorName !== '' ? (
                                          <div key={item.color.id} data={item.color.id} className={item.color.id == selectedColor ? 'active p-0 pointer' : 'p-0 pointer'}
                                              onClick={(e) => handleColorClick(e)}>
                                               <img id={i} className="w-100" src={img[item.color.sku]} alt={item?.color?.colorName} />{item.sku}
                                          </div>
                                      ) : (null)
                                    })
                                  }
                              </div>
                            </div>
                            ):(null)
                        }

                        {
                            size && size.length > 0 && size[0]?.colorSize !== null ? (
                                <div className="col-12 p-0 properties size">
                                    <span>Kích cỡ</span>
                                    {/* <span className="ms-3 custom-parent">
                                      <img className="ruler" src="/static/image/thuoc_ke.svg" alt="icon" />
                                      (<span className="text-decoration-underline" onClick={()=>setShowSize(!showSize)}>Hướng dẫn chọn size</span>)
                                    </span> */}
                                    {
                                        showSize ? (
                                          <div className="row parent-fixed m-0">
                                          <div className="col-12 p-0">
                                            <div className="row custom__image--size">
                                              <div className="col-12">
                                                <div className="row align-items-center">
                                                  <div className="col-6 text-start">
                                                    <span className="title color-link-blue">Hướng dẫn chọn size</span>
                                                  </div>
                                                  <div className="col-6 text-end">
                                                    <i onClick={()=>setShowSize(!showSize)} className="bi bi-x fs-3"></i>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="col-12 p-0">
                                                <img src="/static/image/image_size.svg" alt="" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        ):(null)
                                      }
                                    <div className="row">
                                        {
                                            size?.map((item) => (
                                                item.colorSize !== null ? (
                                                    item.online === true ? (
                                                    <div className={selectedSize === item.sku ? "active pointer" : "pointer"  }key={item.sku}
                                                        sku={item.sku}
                                                        id={item.colorSize} onClick={(e) => handleSizeClick(e)}>
                                                        <span sku={item.sku}>{item.colorSize}</span>
                                                    </div>) : (<div key={item.sku}
                                                        sku={item.sku} className="col-2 disable-text"
                                                        id={item.colorSize}>
                                                        <span>{item.colorSize}</span>
                                                    </div>)

                                                ) : (null)
                                            ))
                                        }
                                    </div>
                                    <input ref={sizeRef} hidden name="size" defaultValue={selectedSize} />
                                </div>
                            ) : (null)
                          }
                      </>
                    ) : (null)
                }
                
                

                
                <div className="col-12 quatity">
                  <div className="row align-items-center">
                    <div className="col-2 p-0"><span>Số lượng</span></div>
                    <div className="col-6 p-0 change_quatity d-flex justify-content-start fs-5 detail-qty">
                      <button onClick={handleMinusClick}><i className="bi bi-dash"></i></button>
                      { 
                        fgGift?(<input type="number"  id={"quantity_" + item.item?.sku}  readOnly min="1" max="50" ref={quanityRef} className="value_quatity" name="quantity"
                           defaultValue={quantity} onChange={handleChange}></input>):
                        (<input type="number" min="1" max="50" ref={quanityRef} className="value_quatity" name="quantity" defaultValue={quantity} onChange={handleChange}></input>)
                      }
                      <button onClick={handlePlusClick}><i className="bi bi-plus"></i></button>
                    </div>
                  </div>
                </div>
                {
                      item.item?.online === false ? (
                          <div className="col-12 p-0 detail-store pb-3">
                              <ul>
                                  <li></li>
                                  <li> <a className="link_cuahang"><div >Sản phẩm không bán online.</div></a></li>
                              </ul>
                          </div>
                      ) : (null)
                  }

                {
                itemProductGift.length > 0 ? (
                  <div className="col-12 related-sale">
                    <div className="row mx-0">
                      <div className="col-6 text-start p-0 m-0">
                        <span>Có {itemProductGift.length} sản phầm cùng khuyến mại</span>
                      </div>
                      <div className="col-6 text-end p-0 m-0 pe-3 position-relative" onClick={handleShowpoppup}>
                          <span className="pointer">Xem tất cả <i className="bi bi-chevron-right"></i></span>
                      </div>

                      <div className="col-12 mt-2 related_list p-0">
                        <div className="row m-0">

                          {
                            itemProductGift.slice(0,4).map((itemGift, i)=>{
                              return <div className="col-6 p-0 box-product-gift-detail-page ">
                              <div className="row m-0">
                                <div className="col-4 p-0 m-0">
                                  <Img imgTitle={itemGift?.name} url={itemGift.thumbnail.replace('origin','thumb')} className="" style=""/>
                                </div>
                                <div className="col-8 p-0 m-0 ps-2">
                                  <div className="row p-0 m-0">
                                    <div className="col-12 p-0 m-0" >
                                      <span className="name-gift">{itemGift.name.substring(0,42)+'...'}</span>
                                    </div>
                                    <div className="col-12 p-0 pt-2 d-flex m-0 justify-content-between">
                                      <div className="price-gift">{FromatNumberVIE(itemGift.price?.discount)}<span className="text-decoration-underline">đ</span></div>
                                      <div className="change_quatity">
                                        <button onClick={() => handleListMinusClick(itemGift.sku, itemGift, false)}><i className="bi bi-dash"></i></button>
                                        <input type="number" readOnly min="0" max="50"  className="value_quatity"  id={"quantity_" + itemGift.sku} name="quantity" defaultValue={0} onChange={handleChangeGift}></input>
                                        <button  onClick={() => handleListPlusClick(itemGift.sku, itemGift, false)}><i className="bi bi-plus"></i></button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            })
                          }
                        </div>
                      </div>
                    </div>
                  </div>  
                ):(null)
                }
              
                {
                    // chọn quà tặng

                    itemsListPromotion.length > 0 ? (
                      <div className="col-12 gift p-0">
                        <div className="row align-items-center mx-1">
                          <div className="col-6 text-start p-0">
                          <img className="icon_gift me-2" src="/static/image/gift-icon.svg" alt="" /><span>Quà tặng</span>
                          </div>
                          <div className="col-6 text-end p-0 pe-3 gift-item position-relative" onClick={handleShowpoppup}>
                              <span className="pointer">Xem tất cả <i className="bi bi-chevron-right"></i></span>
                          </div>
                        </div>
                        <div className="row position-relative gift_list mx-1">
                            <Carousel key="product-gift-promotion"
                                responsive={responsiveproductlist}
                                showDots={false}
                                slidesToSlide={4}
                                infinite={true}
                                // autoPlay={true}
                                // autoPlaySpeed={10000}
                            >
                                {
                                    itemsListPromotion.map((gift, i) => {
                                        return <div key={i}>
                                                <div className="col-12">
                                                  <img className="pading-img" src={gift.thumbnail_gifts.replace('/fullhd', '/thumb')} alt={gift.sku_name_gifts} title={gift.sku_name_gifts}/>
                                                </div>
                                                <div className="col-12 change_quatity">
                                                  <button onClick={() => handleListMinusClick(gift.sku + gift.sku_gifts, gift, true)}><i className="bi bi-dash"></i></button>
                                                  <input type="number" readOnly min="0" max="50" id={"quantity_" + gift.sku + gift.sku_gifts} 
                                                  className="value_quatity" name="quantity"  value={gift.quantity ? gift.quantity : 0}  onChange={handleChangeGift}></input>
                                                  <button onClick={() => handleListPlusClick(gift.sku + gift.sku_gifts, gift, true)}><i className="bi bi-plus"></i></button>
                                                </div>
                                              </div>
                                    })
                                }
                            </Carousel>
                         </div>
                    </div>
                    ) : (null)
                }

                <div className="col-12 mt-1 p-0">
                  <div className="row">
                    <div className="col-12 custom-parent">
                      {/* <i className="bi bi-geo-alt fs-5"></i> */}
                      <img src="/static/image/location.svg" alt="icon" />
                      <span>
                      {
                        store > 0 ? (
                            <>
                            <span className="link_cuahang " >{store} cửa hàng </span><span>gần bạn đang có sản phẩm này</span>
                            </>
                        ) : (
                            <span> Chưa có thông tin cửa hàng.</span>
                        )
                    }
                          
                    </span>
                    </div>
                    {
                      showmap ? (
                        <div className="row parent-fixed">
                          <div className="col-12">
                            <div className="row custom__image--map p-3">
                              <div className="col-12">
                                <div className="row align-items-start pb-2 pe-2">
                                  <div className="col-6">
                                    <span className="title">Danh sách cửa hàng</span>
                                  </div>
                                  <div className="col-6 text-end p-0">
                                    <i onClick={()=>setShowMap(!showmap)} className="bi bi-x fs-3"></i>
                                  </div>
                                  <div className="col-12">
                                    <span>Cho phép hệ thống truy cập địa chỉ từ thiết bị của bạn và đề xuất cửa hàng gần nhất</span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-12">
                                <div className="row">
                                  <div className="col-6">
                                    <div className="row ">
                                      <div className="col-12 d-flex input_search--address">
                                        <input type="text" placeholder="Tìm cửa hàng" />
                                        <button><img src="/static/image/icon_search_address.svg" alt="" /></button>
                                      </div>
                                      <div className="col-12 mt-3 select__address">
                                        <div className="row">
                                          <div className="col-6 pe-1">
                                            <select name="tinhthanh">
                                              <option selected value="">Tỉnh thành</option>
                                              <option value="">Hà Nội</option>
                                              <option value="">Hà Nội</option>
                                              <option value="">Hà Nội</option>
                                            </select>
                                          </div>
                                          <div className="col-6 ps-1">
                                            <select name="quanhuyen" id="">
                                              <option selected value="">Quận huyện</option>
                                              <option value="">Quận Nam Từ Niêm</option>
                                              <option value="">Quận Nam Từ Niêm</option>
                                              <option value="">Quận Nam Từ Niêm</option>
                                            </select>
                                          </div>
                                        </div>
                                      </div>

                                      <div className="col-12 mt-3 address_info">
                                        <div className="row">
                                          {
                                            store > 0 ?(
                                              dataStore.map((itemStore, index)=>{
                                                return <div className="col-12 border-bottom py-2">
                                                <div className="row">
                                                  <div className="col-12 address_name">
                                                    <span>{itemStore.store.name}</span>
                                                  </div>
                                                  <div className="col-12 address">
                                                    <span><i className="bi bi-geo-alt"></i>{itemStore.store.address}</span>
                                                  </div>
                                                  <div className="col-12 time_work">
                                                    <span><i className="bi bi-clock"></i> {itemStore.store.working?.open}:00 - {itemStore.store.working?.close}:00</span> <span>
                                                      <img src="/static/image/call-calling.svg" alt="" />024 7309 1168 - Máy lẻ {itemStore.store.code}</span>
                                                  </div>
    
                                                  <div className="col-12 d-flex address_detail justify-content-between align-items-center">
                                                    <a href="#">
                                                      <span>
                                                        <img src="/static/image/icon_chiduong.svg" alt="" /> Chỉ đường
                                                      </span>
                                                      </a>
                                                    <a href="#">
                                                      <span>
                                                        <img src="/static/image/icon_cho_do_xe.svg" alt="" />Chỗ đỗ xe
                                                      </span>
                                                      </a>
                                                    <a href="#" className="zalo">
                                                      <span>
                                                        Nhóm <strong>Zalo</strong>
                                                      </span>
                                                    </a>
                                                  </div>
                                                </div>
                                              </div>
                                              })

                                            ):(null)
                                          }

                                          <div className="col-12 border-bottom py-2">
                                            <div className="row">
                                              <div className="col-12 address_name">
                                                <span>Bibo Mart Sơn Tây, Ba Vì, HN</span>
                                              </div>
                                              <div className="col-12 address">
                                                <span><i className="bi bi-geo-alt"></i> Số 290 Bạch Mai, Q.Hai Bà Trưng, Hà Nội</span>
                                              </div>
                                              <div className="col-12 time_work">
                                                <span><i className="bi bi-clock"></i> 07:00 - 22:00</span> <span><img src="/static/image/call-calling.svg" alt="" />024 7309 1168 - Máy lẻ 10034</span>
                                              </div>

                                              <div className="col-12 d-flex address_detail justify-content-between align-items-center">
                                                <a href="#">
                                                  <span>
                                                    <img src="/static/image/icon_chiduong.svg" alt="" /> Chỉ đường
                                                  </span>
                                                  </a>
                                                <a href="#">
                                                  <span>
                                                    <img src="/static/image/icon_cho_do_xe.svg" alt="" />Chỗ đỗ xe
                                                  </span>
                                                  </a>
                                                <a href="#" className="zalo">
                                                  <span>
                                                    Nhóm <strong>Zalo</strong>
                                                  </span>
                                                </a>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-6">
                                  <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3919.5375883236884!2d106.66556616424587!3d10.779029992333798!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31752f1c06f4e1df%3A0xb14beb5b53cd62b9!2zVHLGsOG7nW5nIMSQ4bqhaSBo4buNYyBCw6FjaCBraG9hIC0gxJDhuqFpIGjhu41jIFF14buRYyBnaWEgVFAuSENN!5e0!3m2!1svi!2s!4v1686185786105!5m2!1svi!2s" width="465" height="450"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div> 
                      ):(null)
                      
                    }
                    <div className="col-12 mt-3">
                      <div className="row action">
                        <div className="col-12 add-to-cart">
                          {
                            showaddtocart && item.item?.online === true && +item.item?.quantity >0 ? (<button onClick={handleBy}>
                                <img src="/static/image/icon_cart.svg" alt="" />
                                Thêm vào giỏ
                              </button>):(<button disabled>
                            <img src="/static/image/icon_cart.svg" alt="" />
                            Thêm vào giỏ
                          </button>)
                          }
                          
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
        </div>

        <div className="related-product related-product pb-3">
          <div className="container row m-auto row--maint">

            <BundleProductV1 sku={item.item?.sku} />
            <ProductSameV1 sku={item.item?.sku} />

          </div>
        </div>

        <div className="detail row row--maint container mx-auto pb-4 product--des">
          <div className="col-12 p-0 py-4">
            <span className="title">Chi tiết sản phẩm</span>
          </div>
          <div className="col-12 p-0 position-relative p-0 mb-4">
          <TabView>
            <TabPanel header="Mô tả sản phẩm">
                {
                    item.item?.attribute ? (<DescriptionV1 des={item.item?.attribute?.description} />) : (null)
                }
            </TabPanel>
            <TabPanel header="Thông tin chi tiết" >
                {
                  <div className="row info_product">
                    <div className="col-10 mb-4">
                      <div className="row">
                        <div className="col-3 attribute"><span>Thương hiệu</span></div>
                        <div className="col-9 attribute_value"><span><a className="text-color" href={item.item?.attribute?.url_brand ? item.item?.attribute?.url_brand+".html" : null}>{item.item?.attribute?.brand_name ? item.item?.attribute?.brand_name : null}</a></span></div>
                      </div>
                      <div className="row">
                        <div className="col-3 attribute"><span>Xuất xứ thương hiệu</span></div>
                        <div className="col-9 attribute_value"><span>{item.item?.attribute?.xuat_xu_thuong_hieu ? item.item?.attribute?.xuat_xu_thuong_hieu : null}</span></div>
                      </div>
                      <div className="row">
                        <div className="col-3 attribute"><span>Nơi sản xuất</span></div>
                        <div className="col-9 attribute_value"><span>{item.item?.attribute?.noi_san_xuat ? item.item?.attribute?.noi_san_xuat : null}</span></div>
                      </div>
                      <div className="row">
                        <div className="col-3 attribute"><span>Độ tuổi sử dụng</span></div>
                        <div className="col-9 attribute_value"><span>{item.item?.attribute?.nhom_tuoi_xu_dung ? item.item?.attribute?.nhom_tuoi_xu_dung : null}</span></div>
                      </div>
                      <div className="row">
                        <div className="col-3 attribute"><span>Trọng lượng</span></div>
                        <div className="col-9 attribute_value"><span>{item.item?.attribute?.trong_luong_san_pham ? item.item?.attribute?.trong_luong_san_pham + "g" : null}</span></div>
                      </div>
                    </div>
                  </div>
                }
            </TabPanel>
        </TabView>
          </div>
        </div>

        {
          showProductGift ? (
            <div className="parent-fixed">
              <div className="row promotion--list m-0 px-3">
                <div className="col-12 p-0 position-sticky z-3">
                  <div className="row pading-title">
                    <div className="col-6 p-0 promotion--title text-start my-auto">
                      <span>Sản phẩm áp dụng khuyến mại</span>
                    </div>
                    <div className="col-6 p-0 text-end" onClick={()=>setShowProductGift(!showProductGift)}>
                      <i className="bi bi-x fs-3"></i>
                    </div>
                    {
                      msgGift.length > 0 ? (
                          <div className="col-12 box-gift-info position-relative p-0 m-0">
                            <span className="gift_info" key={1}>{msgGift[0]}</span>
                            {
                              msgGift.length > 1 ? (<>
                              {
                                msgGift[0].length > 150 ?(<img className="more_icon" onClick={()=>setConfigMsgGift(true)} src="/static/image/icon_1.png" alt="" />):
                                (<><span className="gift_info" key={1}>{msgGift[1]?.substring(0, 142-msgGift[0].length)}...</span>
                                <img className="more_icon" onClick={()=>setConfigMsgGift(true)} src="/static/image/icon_1.png" alt="" /></>)
                              }
                              </>):(null)
                            }
                          </div>
                      ) : (null)
                    }
                  </div>
                </div>

                <div className="col-12 promotion__box p-0">
                  <div className="row promotion-products--list p-0">

                          <Carousel key="product-gift-promotion_1"
                                responsive={responsiveproductlist}
                                showDots={false}
                                fade={true}
                                slidesToSlide={1}
                                autoPlay={true}
                                autoPlaySpeed={10000}
                            >
                                {
                                    itemProductGiftFull.map((item_gift, i) => {
                                      const percen = +item_gift?.price['discount'] / item_gift.price['raw'] * 100;
                                        return  <div className="product__items">
                                                    <div className="col-12 img_thumbnail position-relative overflow-hidden">
                                                    {
                                                      100 - percen > 0 ?(<div className="sale position-absolute p-1 mx-1">-{RoundFloor(100 - percen)}%</div>):(null)
                                                    }
                                                      <Img imgTitle={item_gift?.name} url={item_gift.thumbnail.replace('/origin', '/thumb')} className="" style=""/>
                                                    </div>
                                                    <div className="col-12 name">
                                                      <span> { item_gift?.name?.length > 55 ? ( (item_gift?.name).substring(0, 55) +'...') :(item_gift?.name)} </span>
                                                    </div>
                                                    <div className="col-12 price">
                                                      <span> {FromatNumberVIE(item_gift?.price['discount'])}<span className="text-decoration-underline">đ</span></span>
                                                      {
                                                       (+item_gift?.price['raw']) > (+item_gift?.price['discount']) ?(
                                                                  <span className="price--sale text-decoration-line-through">
                                                                      {
                                                                          +item_gift?.price['raw']>=1000000 ?(
                                                                              <>{FromatNumberVIE(JSON.stringify(item_gift?.price['raw']).substring(0,5))}...</> 
                                                                          ):(
                                                                              <>{FromatNumberVIE(item_gift?.price['raw'])}<span className="text-decoration-underline">đ</span></>
                                                                          )
                                                                      }
                                                                  </span>
                                                              ):(null)
                                                          }
                                                    </div>
                                                    <div className="col-12 change_quatity text-center">
                                                    <button onClick={() => handleListMinusClick(item_gift.sku, item_gift, false)}><i className="bi bi-dash"></i></button>
                                                    <input type="number" readOnly min="0" max="50" className="value_quatity"  id={"quantity_" + item_gift.sku+"_1"} name="quantity" defaultValue={arrayqty[item_gift.sku]??0} onChange={handleChangeGift}></input>
                                                    <button  onClick={() => handleListPlusClick(item_gift.sku, item_gift, false)}><i className="bi bi-plus"></i></button>
                                                    </div>
                                                </div>
                                          })
                                }
                            </Carousel>
                 

                    
                  </div>

                  <div className="row mx-0">
                    <div className="col-12 p-0 qua_tang_them--list bg-white">
                      <div className="row m-0 box gift-poppup">
                        <div className="col-12 text-start">
                        <img className="icon_gift me-2" src="/static/image/gift-icon.svg" alt="" />
                          <span>Quà tặng</span>
                          {itemsListPromotion.length===0?(<ul>
                            <li className="color-red">Mua thêm sản phẩm để chọn quà</li>
                          </ul>):null}
                         
                        </div>
                        <div className="col-12 list">


                        {
                                    itemsListPromotion.map((gift, i) => {
                                        return <React.Fragment key={i}>
                                           <div className="gift--items">
                                           <div className="row">
                                                <div className="col-12 image__gift">
                                                  <img src={gift.thumbnail_gifts.replace('/fullhd', '/thumb')} alt={gift.sku_name_gifts} title={gift.sku_name_gifts}/>
                                                </div>

                                                <div className="col-12 change_quatity">{qty[gift.sku_gifts]}
                                                  <button onClick={() => handleListMinusClick(gift.sku + gift.sku_gifts, gift, true)}><i className="bi bi-dash"></i></button>
                                                  <input type="number" readOnly min="0" max="50" id={"quantity_" + gift.sku + gift.sku_gifts+"_1"} 
                                                  className="value_quatity" name="quantity"
                                                  value={gift.quantity ? gift.quantity : 0}  onChange={handleChangeGift}></input>
                                                  <button onClick={() => handleListPlusClick(gift.sku + gift.sku_gifts, gift, true)}><i className="bi bi-plus"></i></button>
                                                </div>
                                                </div>
                                              </div>
                                        </React.Fragment>
                                    })
                                }
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row mt-3 box-add-to-cart text-end">
                    <div className="col-10 pe-0">
                      <div className="row">
                        <div className="col-12 p-0 choose-gift">
                          <div className="row ">
                            <div className="col-6 text-start choose-gift--title d-flex align-items-end">
                              {
                                itemsListPromotion.length > 0 ? (<><span>Bạn đã chọn </span> <span> &nbsp;{countgift} quà tặng</span></>):(null)
                              }
                              </div>
                            <div className="col-6 ">
                              <div className="title"><span>Tạm tính ({countitem} sản phẩm)</span></div>
                              <span className="price">{FromatNumberVIE(totalprice)}đ</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-2 add-to-cart-gift p-0 my-auto">
                      {showaddtocart?(<button  onClick={handleBy}>Thêm vào giỏ</button>):(<button disabled>Thêm vào giỏ</button>)}
                    </div>
                  </div>
                </div>
              </div>
            </div>  
           ):(null)
         }
              
        
      </div>
      <div className={scrollPosition > showH ? ("d-block d-flex justify-content-center fix-product--addcart"):("d-none d-flex justify-content-center fix-product--addcart")}>
        <div className="row product_fixed row--maint">
          <div className="col-6 p-0 d-flex align-items-center">
            <div className="row">
              <div className="col-12">
                <span className="name">{item.item?.name}</span>
              </div>
              <div className="col-12 price align-items-center d-flex align-self-center">
              {
                  item.item?.price ? (
                        +item.item?.price.discount == +item.item?.price.raw ? (
                          <>
                              <span className="new">{FromatNumberVIE(item.item?.price.raw)}đ</span>
                          </>
                      ) : (
                          <>
                              <span className="new">{FromatNumberVIE(item.item?.price.discount)}đ</span>
                              <span className="old"><del>{FromatNumberVIE(item.item?.price.raw)}đ</del></span>
                              <span className="sale">-{RoundFloor(100 - percen)}%</span>
                          </>

                      )
                  ):(null)
                }

              </div>
            </div>
          </div>

          <div className="col-6 p-0 action add-to-cart d-flex justify-content-end align-items-center">
          {
            item.item?.online === true && +item.item?.quantity >0 ? (
              <button  onClick={handleBy}>
              <img src="/static/image/icon_cart.svg" alt="" />
              Thêm vào giỏ
            </button>
            ):(
              <button  disabled>
              <img src="/static/image/icon_cart.svg" alt="" />
              Thêm vào giỏ
            </button>
            )

          }
            
          </div>
        </div> 
      </div>
      <div id="modal-msg">
          {configMsg === true ? (
          <div className="modal">
              <div className="modal-content">
                  <div className="modal-body p-0">
                      <div>
                      Sữa mẹ là thức ăn tốt nhất cho sức khỏe và sự phát triển toàn diện của trẻ sơ sinh và trẻ nhỏ! Vui lòng xác nhận bạn là nhân viên y tế hoặc có nhu cầu tìm hiểu thông tin về sản phẩm theo chỉ dẫn của nhân viên y tế.
                      </div>
                      <div className="text-right mgt-10">
                          <button onClick={() => setConfigMsg(false)} className="btn-cancel pdy-10 mgt-10">
                              Xác nhận
                          </button>
                      </div>
                  </div>
              </div>
          </div>
          ):(null)}
      </div>

      <div id="modal-msg">
          {configMsgGift === true ? (
          <div className="modal product-detail">
              <div className="modal-content">
                  <div className="modal-body p-0 gift-poppup">
                    <div className="col-12 p-0 d-flex justify-content-between header">
                      <div className="d-flex justify-content-start font-title">Chương trình khuyến mại</div>
                      <div className="d-flex justify-content-end pointer"> <img onClick={()=>setConfigMsgGift(false)} src="/static/image/icon_close.png" alt="" /></div>
                    </div>
                  {
                    msgGift.length > 0 ? (
                        <div className="col-12 p-0">
                          {
                              msgGift.map((item, i) => {
                                  return <> <div className="gift-poppup--box" key={i}>{item}</div></>
                              })
                          }
                        </div>
                    ) : (null)
                  }
                  </div>
              </div>
          </div>
        ):(null)} 
      </div>

      {/* <div className="button__go--gift">
        <div className="row m-0 row-gap-2">
          <div className="col-12 p-0">
            <div className="bg-white text-center">
              <img src="/static/image/image_gif_qua.gif" alt="" />
            </div>
          </div>
        </div>
      </div> */}
    </>
    )
}
export default Productdetail;